import React from 'react';
import { Clock } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Hero() {
  return <section className="relative overflow-hidden bg-cream pt-20 pb-24 lg:pt-32 lg:pb-32" data-id="element-131">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-132">
        <div className="grid grid-cols-1 gap-y-16 lg:grid-cols-2 lg:gap-x-16 lg:items-center" data-id="element-133">
          {/* Text Content */}
          <div className="max-w-2xl" data-id="element-134">
            <FadeIn delay={0.1} data-id="element-135">
              <div className="inline-flex items-center gap-2 rounded-full bg-amber-light px-4 py-1.5 text-sm font-medium text-amber mb-8" data-id="element-136">
                <Clock className="h-4 w-4" data-id="element-137" />
                <span data-id="element-138">Sound familiar?</span>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-139">
              <h1 className="font-serif text-4xl font-black tracking-tight text-navy sm:text-6xl mb-6 leading-[1.1]" data-id="element-140">
                The Screen-Free Sanity Playbook
              </h1>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-141">
              <h2 className="text-xl font-medium text-navy-light mb-8 leading-relaxed" data-id="element-142">
                Reclaim your 5 PM "Witching Hour" and end the screen-time guilt
                with 50 simple, zero-prep activities that actually keep them
                busy.
              </h2>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-143">
              <p className="text-lg text-muted mb-10 leading-relaxed" data-id="element-144">
                It's 5:15 PM. You're trying to get dinner on the table, but the
                "melt-down" has already started. You're exhausted, they're
                overstimulated, and the iPad feels like the only way to get
                twenty minutes of peace.
                <br data-id="element-145" />
                <br data-id="element-146" />
                You don't want to park them in front of a screen again, but you
                don't have the mental energy to invent a craft project or clean
                up another massive sensory-bin mess. You just need a win.
              </p>
            </FadeIn>

            <FadeIn delay={0.5} data-id="element-147">
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-148">
                <button onClick={() => document.getElementById('final-cta')?.scrollIntoView({
                behavior: 'smooth'
              })} className="inline-flex justify-center items-center rounded-full px-8 py-4 text-lg font-semibold text-white shadow-soft transition-all hover:bg-amber-hover hover:scale-[1.02] active:scale-[0.98] bg-amber" data-id="element-149">
                  Get the Playbook
                </button>
              </div>
            </FadeIn>
          </div>

          {/* Image */}
          <FadeIn delay={0.3} direction="left" className="relative lg:ml-auto flex justify-center lg:justify-end" data-id="element-150">
            <div className="relative w-full max-w-lg" data-id="element-151">
              {/* Decorative background blob/shape */}
              <div className="absolute -inset-4 rounded-full bg-teal-light/50 blur-3xl" data-id="element-152" />

              <img src="https://cdn.magicpatterns.com/uploads/p8MBvbEhvnXxNmdGaYEbFe/The_Screen-Free_Sanity_Playbook_image_2.png" alt="The Screen-Free Sanity Playbook on an iPad" className="relative z-10 w-full rounded-2xl shadow-soft-lg transform rotate-[-2deg] transition-transform hover:rotate-0 duration-500" data-id="element-153" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}